/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_UnauthorizedInputs */

const en_chat_error_unauthorized = /** @type {(inputs: Chat_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication expired. Please sign in again.`)
};

const fr_chat_error_unauthorized = /** @type {(inputs: Chat_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification expirée. Reconnecte-toi.`)
};

const ms_sg2_chat_error_unauthorized = /** @type {(inputs: Chat_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengesahan tamat. Sila log masuk semula.`)
};

/**
* | output |
* | --- |
* | "Authentication expired. Please sign in again." |
*
* @param {Chat_Error_UnauthorizedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_error_unauthorized = /** @type {((inputs?: Chat_Error_UnauthorizedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_UnauthorizedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_error_unauthorized(inputs)
	if (locale === "fr") return fr_chat_error_unauthorized(inputs)
	return ms_sg2_chat_error_unauthorized(inputs)
});